import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './MobileNav.css';
import { APP_NAV_ITEMS, NavigationIcon, PUBLIC_NAV_ITEMS } from './navigation';

function MobileNav({ loggedInUser, orgMember, logout, appView, demoSchedulingUrl, onScheduleDemo }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKey = (event) => { if (event.key === 'Escape') setIsOpen(false); };
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKey);
    return () => { document.body.style.overflow = ''; document.removeEventListener('keydown', handleKey); };
  }, [isOpen]);

  const close = () => setIsOpen(false);
  const items = loggedInUser ? APP_NAV_ITEMS : PUBLIC_NAV_ITEMS;

  return (
    <div className="mobile-nav">
      <button className="mobile-nav-button" type="button" onClick={() => setIsOpen(true)} aria-expanded={isOpen} aria-label="Open navigation">
        <NavigationIcon name="menu" size={23} />
      </button>

      {isOpen && (
        <>
          <button className="mobile-nav-backdrop" type="button" onClick={close} aria-label="Close navigation" />
          <div className="mobile-nav-panel" role="dialog" aria-modal="true" aria-label="Navigation">
            <div className="mobile-nav-heading"><strong>Navigate</strong><button type="button" onClick={close} aria-label="Close navigation"><NavigationIcon name="close" /></button></div>
            <nav>
              {items.map((item) => (
                <NavLink key={item.path} to={item.path} end={item.path === '/'} onClick={close} className={({ isActive }) => isActive ? 'active' : ''}>
                  {item.icon && <NavigationIcon name={item.icon} />}
                  <span>{item.label}</span>
                </NavLink>
              ))}
              {loggedInUser && orgMember?.is_admin && <NavLink to="/operations" onClick={close}><NavigationIcon name="admin" /><span>Operations</span></NavLink>}
              {loggedInUser && <NavLink to="/help" onClick={close}><NavigationIcon name="help" /><span>Help</span></NavLink>}
              {loggedInUser && <NavLink to="/account" onClick={close}><NavigationIcon name="organization" /><span>Account settings</span></NavLink>}
            </nav>
            <div className="mobile-nav-legal"><NavLink to="/privacy-policy" onClick={close}>Privacy Policy</NavLink></div>
            <div className={`mobile-nav-footer${!loggedInUser && !appView ? ' mobile-nav-footer-public' : ''}`}>
              {loggedInUser ? <button type="button" onClick={() => { close(); logout(); }}>Sign out</button> : <>{!appView && <a className="mobile-nav-demo" href={demoSchedulingUrl} target="_blank" rel="noreferrer" onClick={() => { onScheduleDemo?.('mobile_nav'); close(); }}>Schedule a demo</a>}<NavLink to="/signin" onClick={close}>Sign in</NavLink>{!appView && <NavLink className="mobile-nav-primary" to="/signup" onClick={close}>Get started</NavLink>}</>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default MobileNav;
